module.exports = __webpack_public_path__ + "img/ebook-hero-bg.b6584e28.jpg";